"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const classnames_1 = __importDefault(require("classnames"));
const polished_1 = require("polished");
const _1 = require("../.");
/**
 * Allows to upload multiple images at once.
 */
const GalleryUpload = ({ name, value, mandatory, setValue, columns = 4, }) => {
    const classes = useStyles({ columns });
    return (react_1.default.createElement("div", { className: classes.root },
        value &&
            value.map((item, index) => react_1.default.createElement("div", { className: classes.item, key: index },
                react_1.default.createElement("div", { className: classes.imageWrapper },
                    react_1.default.createElement("img", { src: typeof item === 'object' ? item.data : item, className: classes.image, alt: `Uploaded file ${index}` }),
                    react_1.default.createElement("div", { className: classes.delete, onClick: () => setValue(name, value.filter((_subItem, subIndex) => subIndex !== index), mandatory, { touched: true }) }, "\u2A2F")))),
        react_1.default.createElement("div", { className: classes.item },
            react_1.default.createElement("input", { accept: 'image/*', className: classes.input, id: name, multiple: true, type: 'file', onChange: (e) => {
                    let oldValue = value || [];
                    const files = e.target.files;
                    Object.values(files).forEach(value => {
                        const fileReader = new FileReader();
                        const { name: fileName, type: fileType } = value;
                        const dataFile = value;
                        fileReader.readAsDataURL(value);
                        fileReader.onload = () => {
                            const data = fileReader.result;
                            setValue(name, [...oldValue, {
                                    fileName,
                                    type: fileType.split('/')[0],
                                    data,
                                    dataFile,
                                }], mandatory, { touched: true });
                            oldValue = [...oldValue, {
                                    fileName,
                                    type: fileType.split('/')[0],
                                    data,
                                    dataFile,
                                }];
                        };
                    });
                } }),
            react_1.default.createElement("label", { htmlFor: name, className: (0, classnames_1.default)(classes.imageWrapper, classes.label) }, "Add more"))));
};
const useStyles = (0, react_jss_1.createUseStyles)((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        margin: -10,
    },
    item: {
        maxWidth: '50%',
        minWidth: '50%',
        padding: 10,
        boxSizing: 'border-box',
        [(0, _1.breakpoint)(theme.breakpoints.md)]: {
            maxWidth: ({ columns }) => `${100 / columns}%`,
            minWidth: ({ columns }) => `${100 / columns}%`,
        },
    },
    imageWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.colors.fill,
        padding: 15,
        height: '33vw',
        position: 'relative',
        [(0, _1.breakpoint)(theme.breakpoints.md)]: {
            height: '20vw',
        },
        [(0, _1.breakpoint)(theme.breakpoints.lg)]: {
            height: '12vw',
            maxHeight: 300,
        },
    },
    image: {
        maxWidth: '100%',
        maxHeight: '100%',
    },
    delete: {
        position: 'absolute',
        top: '-0.5em',
        right: 0,
        lineHeight: '30px',
        fontSize: 30,
        padding: 5,
        cursor: 'pointer',
        '&:hover': {
            color: theme.colors.inputBorder,
        },
    },
    input: {
        display: 'none',
    },
    label: {
        display: 'flex',
        flexDrection: 'column',
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.colors.inputText,
        '&:hover': {
            backgroundColor: (0, polished_1.lighten)(0.04, theme.colors.fill),
        },
    },
}));
exports.default = (0, _1.withFormControl)(GalleryUpload);
